export default {
  methods: {
    translateErrors(errors) {
      if (errors.error_keys) {
        const translatedErrors = Object.keys(errors.error_keys).reduce(
          (acc, key) => {
            acc[key] = this.$t(`_errors.${errors.error_keys[key]}`);
            return acc;
          },
          {},
        );
        errors = {
          ...errors,
          ...translatedErrors,
        };
        delete errors.error_keys;
      }
      return errors;
    },
  },
};
